'use strict'

import Vue from 'vue'

export const eventType = {
  cancelModule: 'cancelModule',
  updateClients: 'updateClients',
  updateAdTextItems: 'updateAdTextItems'
}

export const eventBus = new Vue({
  methods: {
    emitCancelModule () {
      this.$emit(eventType.cancelModule)
    },
    emitUpdateClients (value) {
      this.$emit(eventType.updateClients, value)
    },
    emitUpdateAdTextItems (value) {
      this.$emit(eventType.updateAdTextItems, value)
    },
    subscribe (event, callback) {
      this.$on(event, callback)
    },
    off (event, callback) {
      if (callback) {
        this.$off(event, callback)
      } else {
        this.$off(event)
      }
    }
  }
})
